<template>
  <component :is="integration.components.testTool" :model="model" />
</template>

<script>
export default {
  name: 'IntegrationTestTool',
  props: {
    integration: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationTestTool.vue